import { Appointment, Diary, Encounter, Fax, HarloweSupport, Note, ReceivedEmail, SentEmail, User } from "@harlowe/core";
import { Type } from "class-transformer";
import { Member } from "./plan";
import { formatDate } from "@angular/common";


export class TealHealthEncounter extends Encounter
{

    constructor
    (
        id: number,
        encounterCreationDate: Date,
        encounterCompletionDate: Date,
        assignedTo: User,
        patientMember: Member,
        public status: number,
        attachments: HarloweSupport.File[],
        appointments: Appointment[]
    )
    {
        super(id,encounterCreationDate,encounterCompletionDate, assignedTo, appointments)
        this.patientMember = patientMember
        this.attachments = attachments
    }

    @Type(() => Member)
    patientMember: Member;
    
    @Type(() => HarloweSupport.File)
    attachments: HarloweSupport.File[] = []

    public override getDisplayName(): string 
    {
        return `${this.id} - ${formatDate(this.encounterCreationDate,'MM/dd/yyyy','en-US')}`
    }
}

export class TealHealthEncounterDetails extends TealHealthEncounter
{
    @Type(() => Note)
    notes: Note[] = [];
    @Type(() => Diary)
    diaries: Diary[] = [];
    @Type(() => SentEmail)
    sentEmails: SentEmail[] = [];
    
    @Type(() => ReceivedEmail)
    receivedEmails:ReceivedEmail[] = []; 
    
    @Type(() => Fax)
    outboundFaxes: Fax[] = [];
}

export interface TealHealthEncounterHeader
{
    id: number;
    assignedTo?: string;
    assignedToiId?: number;
    createDate?: Date;
    encounterStatus?: string;
    member?: string;
}

export class EncounterStatus
{
    constructor
    ( 
        public description: string,
        public status: number,
        public id: number
    )
    {}

}